<template>
    <v-container>
        <v-row v-if="autorizedIframeInstance" justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(id, index) in autorizedIframeInstance" :key="index" md="6" cols="12">
                        <v-card @click="selectDashboard(id)" class="dashboard">
                            <v-card-title v-text="$t(`IFRAME${instanceNumber}.${clientId}.${id}.title`)"></v-card-title>
                            <v-card-subtitle>{{ $t(`IFRAME${instanceNumber}.${clientId}.${id}.description`) }}</v-card-subtitle>
                            <v-icon class="goto">mdi-application-braces-outline</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            iFramesList: []
        };
    },
    computed: {
        ...mapGetters(['getBookmarkedServices', 'getServices', 'getCurrentClientId']),
        autorizedIframeInstance: function () {
            return this.$store.getters.getAuthorizedInstances || null;
        },
        clientId: function () {
            return this.$store.getters.getCurrentClientId || null;
        },
        instanceNumber: function () {
            return this.$store.getters.getIframeServiceNumber || null;
        }
    },
    methods: {
        selectDashboard(id) {
            this.$store.commit('setDashboardId', id);
            let clientName = this.$store.getters.getClientName;
            let instanceNumberIframe = this.$store.getters.getIframeServiceNumber;
            this.$router.push(`/${clientName}/IFRAME/${instanceNumberIframe}/${id}`);
        },
        async getIFrames() {
            let clientId = this.$store.getters.getCurrentClientId;
            var path = window.location.pathname.split('/');
            let indexOfIframeInPath = path.indexOf('IFRAME');
            let serviceNumber = path[indexOfIframeInPath + 1];
            let autorizedInstances = this.getServices.find(item => item.serviceNumber === serviceNumber);
            let instances =
                autorizedInstances?.instance && autorizedInstances.instance[clientId]
                    ? autorizedInstances.instance[clientId]
                    : null;
            if (instances) {
                this.$store.commit('setIframeServiceNumber', serviceNumber);
                this.$store.commit('setAutorizedIframeInstances', instances);
            } else {
                this.$store.commit('displayErrors', {
                    errno: 3402
                });
            }
        }
    },
    async mounted() {
        this.$store.commit('setDashboardId', null);
        if (this.autorizedIframeInstance.length && this.autorizedIframeInstance.length === 1) {
            this.selectDashboard(this.autorizedIframeInstance[0]);
        }
    },
    watch: {
        async '$store.getters.getCurrentClientId'() {
            if (this.$store.getters.getCurrentClientId) {
                await this.getIFrames();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.dashboard {
    cursor: pointer;
    border-top: 7px solid #fff;
    .v-card__subtitle {
        padding-bottom: 42px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
}
</style>
